import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-email-fax-dialog',
  templateUrl: './email-fax-dialog.component.html',
  styleUrls: ['./email-fax-dialog.component.scss'],
})
export class EmailFaxDialogComponent implements OnInit {
  customerFormGroup: FormGroup;
  customerValidationName: Boolean;
  customerValidationAcc: Boolean;
  customerValidationPhoneNumber: Boolean;
  customerValidationFaxNumber: Boolean;
  customerValidationFaxATTN: Boolean;
  customerValidationEmail: Boolean;
  userValidationName: Boolean;
  userValidationPhoneNumber: Boolean;
  userValidationEmail: Boolean;
  subjectValidation: Boolean;

  constructor(
    public dialogRef: MatDialogRef<EmailFaxDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public dialogData: any
  ) {
    this.customerFormGroup = new FormGroup({
      customerName: new FormControl(''),
      customerAcc: new FormControl(''),
      customerPhoneNumber: new FormControl(''),
      customerFaxNumber: new FormControl(''),
      customerFaxATTN: new FormControl(''),
      customerEmail: new FormControl(''),
      userName: new FormControl(''),
      userPhoneNumber: new FormControl(''),
      userEmail: new FormControl(''),
      subject: new FormControl(''),
      sendOptions: new FormControl('fax'),
    });

    this.customerValidationName = true;
    this.customerValidationAcc = true;
    this.customerValidationPhoneNumber = true;
    this.customerValidationFaxNumber = true;
    this.customerValidationFaxATTN = true;
    this.customerValidationEmail = true;

    this.userValidationName = true;
    this.userValidationPhoneNumber = true;
    this.userValidationEmail = true;
    this.subjectValidation = true;
  }

  generateValidations() {
    this.customerValidationName =
      this.customerFormGroup.get('customerName')?.value !== '';
    this.customerValidationAcc =
      this.customerFormGroup.get('customerAcc')?.value !== '';
    this.customerValidationPhoneNumber =
      this.customerFormGroup.get('customerPhoneNumber')?.value !== '';

    if (this.customerFormGroup.get('sendOptions')?.value === 'fax') {
      this.customerValidationEmail = true;
      this.customerValidationFaxNumber =
        this.customerFormGroup.get('customerFaxNumber')?.value !== '';
      this.customerValidationFaxATTN =
        this.customerFormGroup.get('customerFaxATTN')?.value !== '';
    }

    if (this.customerFormGroup.get('sendOptions')?.value === 'email') {
      this.customerValidationFaxNumber = true;
      this.customerValidationFaxATTN = true;
      this.customerValidationEmail =
        this.customerFormGroup.get('customerEmail')?.value !== '';
    }

    this.userValidationName =
      this.customerFormGroup.get('userName')?.value !== '';
    this.userValidationPhoneNumber =
      this.customerFormGroup.get('userPhoneNumber')?.value !== '';
    this.userValidationEmail =
      this.customerFormGroup.get('userEmail')?.value !== '';
    this.subjectValidation =
      this.customerFormGroup.get('subject')?.value !== '';
  }

  submitForm() {
    this.generateValidations();
  }

  ngOnInit(): void {}

  closeDialog() {
    this.dialogRef.close();
  }
}
